<script setup lang="ts">
    defineProps<{
        name?: string
        imgSrc?: string | null
        modifiers?: string
    }>()
    const getInitials = (name?: string) => {
        if (!name) {
            return ''
        }
        return name
            .split(' ')
            .slice(0, 2)
            .map((n) => n.charAt(0).toUpperCase())
            .join('')
    }
</script>

<template>
    <VvAvatar
        class="pk-avatar"
        :img-src="imgSrc ? imgSrc : undefined"
        :modifiers="`rounded ${!imgSrc ? modifiers : 'transparent'}`">
        <template v-if="name && !imgSrc" #default>
            {{ getInitials(name) }}
        </template>
    </VvAvatar>
</template>

<style lang="scss">
    .pk-avatar {
        // Users can upload any image shape: always crop it to the circle
        // (the inner img inherits object-fit from the avatar root)
        object-fit: cover;
        overflow: hidden;
    }
</style>
